import { createComponentUtils } from "../../__utils/atlas";

const COMPONENT_NAME = "ContentEditor";

export const { ROOT, el, createComponent } =
  createComponentUtils(COMPONENT_NAME);
